export const pdsAnalytics = {
    constants: {
        pageNameNoVehicle: 'fv:dynamic manage:pre-delivery summary',
        pageID: 'dynamic manage',
        contentSubType: 'pre-delivery summary',
        pTemplate: 'none',
        linkType: 'cta',
        clickAction: 'click',
        nameplate: window?.digitaldata?.vehicle?.nameplate || '',
        satelliteTrackId: 'ecommInternalCtaClick',
        pageName: 'fv:dynamic manage:pre-delivery summary',
        siteSection: 'dynamic manage',
        impress: 'impress',
        detailsTabName: 'details',
        nextSteps: 'next steps',
        loginStatus: 'logged in',
        hierarchyPrefix: 'shopping tools:dynamic manage'
    },
    prepareDataLayer: function (value) {
        return {
            onclick: {
                onclickLinkName: `${this.constants.pageNameNoVehicle}:${this.constants.linkType}:${value}:${this.constants.nameplate}`,
                onclick: `${this.constants.pageID}:${this.constants.contentSubType}:${this.constants.linkType} ${this.constants.clickAction}:${value}`,
                contentType: `${this.constants.pageID}:${this.constants.pTemplate}:${this.constants.clickAction}`,
                contentSubType: `${this.constants.contentSubType}`
            }
        }
    },
    prepareDataLayerForAccordionAndBanner: function (eventName, eventValues) {
        if (eventName === 'BannerTypeOnload') {
            return {
                Action: 'pageLoad',
                page: {
                    notificationType: `${eventValues.bannerType}`,
                    pageName: `${this.constants.pageNameNoVehicle}:${eventValues.brand} ${eventValues.modelName}`,
                    pageNameNoVehicle: `${this.constants.pageNameNoVehicle}`,
                    siteSection: `${this.constants.siteSection}`,
                    hierarchy: `${this.constants.hierarchyPrefix}:${eventValues.vehicleCategory}:${eventValues.brand} ${eventValues.modelName}`,
                    dealerID: `${eventValues.paCode}`,
                    radUIVersion: `${eventValues.rad}`
                },
                cart: {
                    paymentMethod: `${eventValues.paymentMethod}`,
                    orderID: `${eventValues.orderId}`,
                    orderType: `${eventValues.orderType}`
                },
                user: {
                    errorTracking: `${eventValues.errorTracking}`,
                    loginStatus: `${this.constants.loginStatus}`
                },

                onclick: {
                    contentType: `${this.constants.siteSection}:${this.constants.pTemplate}:${this.constants.impress}`
                },
                vehicle: {
                    nameplate: `${eventValues.brand} ${eventValues.modelName}`,
                    modelYear: `${eventValues.modelYear}`,
                    bodyModelTrim: `${eventValues.trimStyleDescription}`
                },
                sateliteTrackId: `${eventValues.sateliteTrackId}`
            }
        } else {
            return {
                onclick: {
                    onclickLinkName: `${this.constants.pageNameNoVehicle}:${eventValues.linkType}:${eventName}:${this.constants.nameplate}`,
                    onclick: `${this.constants.pageID}:${eventValues.contentSubType}:${eventValues.linkType} ${this.constants.clickAction}:${eventName}`,
                    contentType: `${this.constants.pageID}:${this.constants.pTemplate}:${this.constants.clickAction}`,
                    contentSubType: `${eventValues.contentSubType}`
                }
            }
        }
    },
    accept: function () {
        return this.prepareDataLayer('accept')
    },
    reject: function () {
        return this.prepareDataLayer('decline notify dealer')
    },
    backToDM: function () {
        return this.prepareDataLayer('back to manage order')
    },
    callDealer: function () {
        return this.prepareDataLayer('call dealer')
    },
    print: function () {
        return this.prepareDataLayer('print')
    },
    download: function () {
        return this.prepareDataLayer('download')
    },
    viewDisclosures: function () {
        return this.prepareDataLayer('view disclosures')
    },
    clickEvent: function (eventName, eventValues) {
        const updatedDataLayer = this.prepareDataLayerForAccordionAndBanner(eventName, eventValues)
        window.digitaldata = window.digitaldata || {}
        window.digitaldata = {
            ...window.digitaldata,
            ...updatedDataLayer
        }
        if (window?._satellite) {
            window._satellite.track(eventValues.sateliteTrackId)
        }
    },
    onLoad: function (eventName, eventValues) {
        const updatedDataLayer = this.prepareDataLayerForAccordionAndBanner(eventName, eventValues)
        window.digitaldata = window.digitaldata || {}
        window.digitaldata = {
            ...window.digitaldata,
            ...updatedDataLayer
        }
        if (window?._satellite) {
            window._satellite.track(eventValues.sateliteTrackId)
        }
    },
    track: function (eventName) {
        const updatedDataLayer = this[eventName]()
        window.digitaldata = window.digitaldata || {}
        window.digitaldata = {
            ...window.digitaldata,
            ...updatedDataLayer
        }
        if (window?._satellite) {
            window._satellite.track(this.constants.satelliteTrackId)
        }
    }
}
